import moment from "moment";

export default function initializeDepartureDate(departure) {
  if (departure.length) {
    return departure;
  }
  return moment().set("hours", 12).set("minutes", 0).format("yyyy-MM-DD HH:mm");
}
